import { NamedLogger } from "@nolimitcity/slot-launcher/bin/utils/Logger";

export interface IColorScheme {
    textColor: string;
    backgroundColor: string;
    logLevel?: number;
}

interface IColorSet {
    DEFAULT: IColorScheme;
    GREEN: IColorScheme;
    RED: IColorScheme;
    DARK_RED: IColorScheme;
    LIGHT_RED1: IColorScheme;
    LIGHT_RED2: IColorScheme;
    LIGHT_RED3: IColorScheme;
    BLACK: IColorScheme;
    YELLOW: IColorScheme;
    ORANGE: IColorScheme;
    BLUE: IColorScheme;
    PURPLE: IColorScheme;
    IDLE: IColorScheme;
    BET: IColorScheme;
    RESULT: IColorScheme;
    WIN: IColorScheme;
}

export const ColorSet: IColorSet = {
    DEFAULT: { textColor: `red`, backgroundColor: `lightyellow ` },
    GREEN: { textColor: `white`, backgroundColor: `green` },
    RED: { textColor: `white`, backgroundColor: `red` },
    DARK_RED: { textColor: `white`, backgroundColor: `#8b0000` },
    LIGHT_RED1: { textColor: `white`, backgroundColor: `#de3163` },
    LIGHT_RED2: { textColor: `white`, backgroundColor: `#ff6961` },
    LIGHT_RED3: { textColor: `white`, backgroundColor: `#cd5c5c` },
    BLACK: { textColor: `white`, backgroundColor: `black` },
    YELLOW: { textColor: `black`, backgroundColor: `yellow` },
    ORANGE: { textColor: `white`, backgroundColor: `darkorange` },
    BLUE: { textColor: `white`, backgroundColor: `blue` },
    PURPLE: { textColor: `white`, backgroundColor: `purple` },
    IDLE: { backgroundColor: `#fb7400`, textColor: `white` },
    BET: { backgroundColor: `#EC167F`, textColor: `white` },
    RESULT: { backgroundColor: `#292E6C`, textColor: `white` },
    WIN: { backgroundColor: `#467510`, textColor: `white` },
};

let logger: NamedLogger;
let gameName: string = ``;
export const initializeGameLogger = (logId: string) => {
    gameName = logId;
    logger = new NamedLogger(gameName);
};

export const log = (
    message: string,
    scheme: IColorScheme = ColorSet.DEFAULT,
    extraMessage: any | undefined = undefined
) => {
    logger.log(
        `%cLog: ${message}`,
        `background: ${scheme.backgroundColor}; 
            color: ${scheme.textColor}; 
            font-weight:bold;`,
        extraMessage !== undefined ? extraMessage : ``
    );
};
